import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Popup } from "../../../../library/popup";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { TransparentButton, SolidButton } from "../../../../library/button";
import {
  changeCampaignsModal,
  requestDistributionSelections,
  requestSendBulkEmails,
  requestSendBulkSms,
} from "../../../../../redux/actions/campaigns";
import { Input } from "../../../../library/input";
import { Select } from "../../../../library/select";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { Label } from "../../../../library/label";
import "./style.scss";
import Text from "../../../../library/text";

const Index = () => {
  const dispatch = useDispatch();

  const modalState = useSelector(
    (state) => state.campaigns.showModals.distributeModal
  );

  const fetchLoading = useSelector(
    (state) => state.campaigns.fetchDistributionSelections.loading
  );
  const sendEmailLoading = useSelector(
    (state) => state.campaigns.sendBulkEmails.loading
  );

  const sendSmsLoading = useSelector(
    (state) => state.campaigns.sendBulkSms.loading
  );

  const companyId = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const activeChannel = useSelector((state) => state.campaigns.activeChannel);

  const allContactLists = useSelector(
    (state) => state.campaigns.fetchDistributionSelections.data.contactLists
  );
  const allTemplates = useSelector(
    (state) => state.campaigns.fetchDistributionSelections.data.templates
  );

  const domain = useSelector(
    (state) => state.campaigns.activeChannel.source.status.domain
  );

  const [sendDetails, setSendDetails] = useState({
    contactList: null,
    template: null,
    subject: null,
    sender: null,
  });

  const handleClose = () => {
    dispatch(changeCampaignsModal({ distributeModal: false }));
  };

  const distributeEmail = () => {
    if (sendDetails.contactList && sendDetails.template) {
      dispatch(
        requestSendBulkEmails({
          companyId: companyId,
          channelId: activeChannel.id,
          template: sendDetails.template,
          contactList: sendDetails.contactList,
          subject: sendDetails.subject,
          sender: sendDetails.sender,
          username: activeChannel.username,
        })
      );
    } else {
      sendErrorNotification("Vennligst velg en kontaktliste og en mal.");
    }
  };

  const distributeSms = () => {
    if (sendDetails.contactList && sendDetails.template) {
      dispatch(
        requestSendBulkSms({
          companyId: companyId,
          channelId: activeChannel.id,
          template: sendDetails.template,
          contactList: sendDetails.contactList,
          sender: activeChannel.source?.status?.number,
        })
      );
    } else {
      sendErrorNotification("Vennligst velg en kontaktliste og en mal.");
    }
  };

  const renderLoadingList = () => {
    return [
      {
        id: 0,
        value: "",
        title: "Henter..",
        selected: true,
        disabled: true,
      },
    ];
  };

  const renderContactLists = () => {
    const phases = [
      {
        id: 0,
        value: "",
        title: "Velg",
        selected: true,
        disabled: true,
      },
    ];
    allContactLists &&
      allContactLists.map((single, index) => {
        phases.push({
          id: index + 1,
          value: single.id,
          title: single.title,
          selected: false,
          disabled: false,
        });
      });
    return phases;
  };

  const renderTemplate = () => {
    const phases = [
      {
        id: 0,
        value: "",
        title: "Velg",
        selected: true,
        disabled: true,
      },
    ];
    allTemplates &&
      allTemplates.map((single, index) => {
        phases.push({
          id: index + 1,
          value: single.id,
          title: single.title,
          selected: false,
          disabled: false,
        });
      });
    return phases;
  };

  useEffect(() => {
    dispatch(
      requestDistributionSelections({
        companyId: companyId,
        type: activeChannel.type,
      })
    );
  }, []);

  const renderSendButton = () => {
    if (fetchLoading) {
      return (
        <SolidButton
          color="blue"
          disabled
          title="Laster inn"
          icon={<i className="fas fa-circle-notch fa-spin"></i>}
          type="button"
        />
      );
    } else {
      if (activeChannel.type === "email") {
        return (
          <SolidButton
            color="blue"
            title={
              sendEmailLoading
                ? "Sender.."
                : `Send ${activeChannel.type === "email" ? "e-post" : "SMS"}`
            }
            icon={
              sendEmailLoading ? (
                <i className="fas fa-circle-notch fa-spin"></i>
              ) : (
                <i className="fas fa-plus"></i>
              )
            }
            onClick={() => distributeEmail()}
            type="button"
          />
        );
      } else {
        return (
          <SolidButton
            color="blue"
            title={
              sendSmsLoading
                ? "Sender.."
                : `Send ${activeChannel.type === "email" ? "e-post" : "SMS"}`
            }
            icon={
              sendSmsLoading ? (
                <i className="fas fa-circle-notch fa-spin"></i>
              ) : (
                <i className="fas fa-plus"></i>
              )
            }
            onClick={() => distributeSms()}
            type="button"
          />
        );
      }
    }
  };

  const renderSender = () => {
    if (activeChannel.type === "email") {
      return sendDetails.sender;
    } else {
      return activeChannel.source?.status?.number;
    }
  };

  const renderSmallInformation = () => {
    if (activeChannel.type === "email") {
      return `E-posten du sender fra må være fra "@${domain}".`;
    } else {
      return "SMS-en kan kun bli sendt fra et nummer per kanal.";
    }
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Ny utsendelse"
      description="Gjør en ny utsendelse ved å fylle inn feltene nedenfor. Husk å dobbeltsjekk at du har valgt riktig mal."
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        renderSendButton(),
      ]}
    >
      <div className="compose-new-email-content-container">
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Kontaktliste
            </Label>
            {fetchLoading ? (
              <Select items={renderLoadingList()} />
            ) : (
              <Select
                onChange={(e) =>
                  setSendDetails({
                    ...sendDetails,
                    contactList: e.target.value,
                  })
                }
                items={renderContactLists()}
              />
            )}
          </Col>
        </Row>
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Mal
            </Label>
            {fetchLoading ? (
              <Select items={renderLoadingList()} />
            ) : (
              <Select
                onChange={(e) =>
                  setSendDetails({ ...sendDetails, template: e.target.value })
                }
                items={renderTemplate()}
              />
            )}
          </Col>
        </Row>
        {activeChannel.type === "email" && (
          <Row className="info-row">
            <Col className="info-col">
              <Label version={1} weight="bold">
                Emne
              </Label>
              <Input
                placeholder="Emne"
                disabled={fetchLoading ? true : false}
                onChange={(e) =>
                  setSendDetails({ ...sendDetails, subject: e.target.value })
                }
                value={sendDetails.subject}
              />
            </Col>
          </Row>
        )}
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Avsender
            </Label>
            {activeChannel.type === "email" ? (
              <Input
                placeholder="Avsender"
                value={renderSender()}
                onChange={(e) =>
                  setSendDetails({ ...sendDetails, sender: e.target.value })
                }
              />
            ) : (
              <Input
                international={true}
                countryCallingCodeEditable={false}
                format="phone"
                value={renderSender()}
                placeholder="Telefon"
                type="text"
                disabled={true}
              />
            )}

            <Text size="small">{renderSmallInformation()}</Text>
          </Col>
        </Row>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
